import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import Button from '../../components/common/Button/Button';
import Input from '../../components/common/Input/Input';
import { educationCategoryService } from '../../services/educationCategoryService';
import styles from './EducationCategory.module.css';

const EducationCategoryForm = ({ isOpen, onClose, categoryToEdit, refreshData }) => {
    const [topic, setTopic] = useState('');
    const [display, setDisplay] = useState(true);
    const [sortOrder, setSortOrder] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (categoryToEdit) {
            setTopic(categoryToEdit.topic || '');
            setDisplay(categoryToEdit.display !== undefined ? categoryToEdit.display : true);
            setSortOrder(categoryToEdit.sort_order || 0);
        } else {
            setTopic('');
            setDisplay(true);
            setSortOrder(0);
        }
    }, [categoryToEdit]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!topic.trim()) {
            toast.error("Category Topic is required");
            return;
        }

        const payload = {
            topic,
            display,
            sort_order: parseInt(sortOrder) || 0
        };

        setLoading(true);
        try {
            if (categoryToEdit) {
                await educationCategoryService.update(categoryToEdit.id, payload);
                toast.success('Category updated successfully');
            } else {
                await educationCategoryService.create(payload);
                toast.success('Category created successfully');
            }
            refreshData();
            onClose();
        } catch (error) {
            console.error(error);
            toast.error(error.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <ToastContainer position="bottom-right" autoClose={2000} />
            <div className={styles.modalContent}>
                <h3>{categoryToEdit ? 'Edit Category' : 'Add New Category'}</h3>
                <form onSubmit={handleSubmit}>
                    <div className={styles.formGroup}>
                        <label>Topic</label>
                        <Input
                            value={topic}
                            onChange={(e) => setTopic(e.target.value)}
                            placeholder="Enter Category Topic"
                        />
                    </div>
                    <div className={styles.formGroup}>
                        <label>Sort Order</label>
                        <Input
                            type="number"
                            value={sortOrder}
                            onChange={(e) => setSortOrder(e.target.value)}
                            placeholder="Enter Sort Order"
                        />
                    </div>
                    <div className={`${styles.formGroup} ${styles.flexCenterGap10}`}>
                        <label className={styles.mB0}>Display</label>
                        <input
                            type="checkbox"
                            checked={display}
                            onChange={(e) => setDisplay(e.target.checked)}
                        />
                    </div>
                    <div className={styles.modalActions}>
                        <Button variant="secondary" onClick={onClose} type="button">Cancel</Button>
                        <Button type="submit" disabled={loading}>
                            {loading ? 'Saving...' : (categoryToEdit ? 'Update' : 'Create')}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EducationCategoryForm;
